import { Suspense } from 'react';
import { LayoutProvider } from './components/layout/core';
import { Outlet } from 'react-router-dom';
import { MasterInit } from './components/layout/MasterInit';
import { AutorizacionInit } from './context/Autenticacion';

/**
 * Raiz de la aplicacion: LayoutProvider (contexto de layout) > AutorizacionInit (Auth) > Outlet (rutas) > MasterInit.
 * Suspense sin fallback para lazy loading de modulos.
 */
const App = () => {
  return (
    <Suspense fallback={<></>}>
      <LayoutProvider>
        <AutorizacionInit>
          <Outlet />
          <MasterInit />
        </AutorizacionInit>
      </LayoutProvider>
    </Suspense>
  );
}

export default App;
